import { useAccountMode } from '../../useAccountMode';

export const useProgressData = ({ quest }) => {
  const { isComplete, progress, triggerCount, premiumTriggerCount } = quest;
  const { mode: accountMode } = useAccountMode();

  const necessaryTriggerCount = {
    standard: triggerCount,
    premium: premiumTriggerCount,
  }[accountMode];

  return {
    necessaryProgress: progress,
    necessaryTriggerCount,
    isVisibleProgress: !isComplete && typeof progress === 'number' && progress <= necessaryTriggerCount,
  };
};
